/** Shared Tasks search; absent fields must not become searchable "undefined" or "null". */
export function matchesTaskSearch(
  row: {
    task?: { title?: string | null; summary?: string | null } | null;
    botName?: string | null;
    groupName?: string | null;
  },
  query: string,
): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;
  return [row.task?.title, row.task?.summary, row.botName, row.groupName]
    .filter((value): value is string => typeof value === "string")
    .join(" ")
    .toLowerCase()
    .includes(normalized);
}
